import React from 'react';
import axios from 'axios';
import url from 'url';
import { config } from '../../constants/Constants';
import $ from 'jquery';
import SprachtestPostMsg from "./SprachtestPostMsg";


class TestStartInfoPage extends React.Component{
    constructor(){
        super();
        this.state = {
            htmlTestPageMidBlock: '',
            htmlTestPageInfoBlock: '',
        }
    }
    componentDidMount() {
        this.getStartTestMidInfoJson();
        this.getStartTestInfoJson();
       /* let el = document.getElementById("sprachtest_csrf_token").innerHTML;
        let token = '';
        if (el) {
            token = el.value;
        }
        console.log(el);*/
    }
    getStartTestInfoJson(){
       /* console.log(window.location.origin);*/
        let homeurl = config.url.API_URL;
        let test, urlpath;
        let jsonUrlInfo;

        if(process.env.NODE_ENV === "development"){
            urlpath = window.location.href+'einstufungstest-italienisch';
            jsonUrlInfo = 'https://sprachtest.local.de/start-mid-block?_format=json';
        }else{
            urlpath = window.location.href;
            jsonUrlInfo = '/start-mid-block?_format=json';
        }


        let urlstr = url.parse(urlpath);
        if(urlstr.path && urlstr.pathname){
            if(urlstr.path === urlstr.pathname){
                test = urlstr.path.split('-')[1];
                if(test=='business'){
                    test = test+'-'+urlstr.path.split('-')[2];
                }
            }else{
                test = urlstr.pathname.split('-')[1];
                if(test=='business'){
                    test = test+'-'+urlstr.path.split('-')[2].split('?')[0];
                }
            }
        }

        if(process.env.NODE_ENV === "development"){
            jsonUrlInfo = 'https://sprachtest.local.de/start-'+test+'?_format=json';
        }else{
            jsonUrlInfo = '/start-'+test+'?_format=json';
        }

        axios.get(jsonUrlInfo).then(data => {
            this.setState({htmlTestPageInfoBlock:data.data.body[0].processed})
        }) .catch(err => {
            console.log('Error happened during fetching!', err);
        });
    }
    getStartTestMidInfoJson(){
        let homeurl = config.url.API_URL;
        let test, urlpath;
        let jsonUrlMidBlock,jsonUrlInfo;

        if(process.env.NODE_ENV === "development"){
            jsonUrlMidBlock = 'https://sprachtest.local.de/start-mid-block?_format=json';
        }else{
            jsonUrlMidBlock = '/start-mid-block?_format=json';
        }

        axios.get(jsonUrlMidBlock).then(data => {
            this.setState({htmlTestPageMidBlock:data.data.body[0].processed})
        }) .catch(err => {
            console.log('Error happened during fetching!', err);
        });
    }
    render(){
        return(
            <div className="info featured-bottom">
               {/* <div id="sprachtest_csrf_token">AXTE34XerXhykGuPc8P0cunPCzx4dy3qmJg6_q1cPtY</div>*/}
                <div className="midInfo" dangerouslySetInnerHTML={{__html:this.state.htmlTestPageMidBlock}}>

                </div>
                <div className="startInfo" dangerouslySetInnerHTML={{__html:this.state.htmlTestPageInfoBlock}}>

                </div>

            </div>
        )
    }
}
export default TestStartInfoPage;
